import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'

import userRoleServices from '../userRoleServices';
import { useAppData } from '../../../../context/AppDataContext';

function UserRoleListPage() {

  const {userRoleDD} = useAppData();

  

  return (
    <AppLayout>
      <div className='container-fluid'>
        <table className='table'>
          <thead>
            <tr>
            <td>ID</td>
            <td>Role</td>
            </tr>
          </thead>
          <tbody>
            {userRoleDD && userRoleDD.map(userRole=>
              <tr>
                <td>{userRole.value}</td>
                <td>{userRole.label}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </AppLayout>
  )
}

export default UserRoleListPage